import { IShowable } from '../Drivers/IShowable';
import {
    createCircleCompleteFunc,
    createCircleProgressFunc,
    extractHTMLRewardedAdElementsFallback,
    getHTMLRewardedAd,
} from './HTMLRewardedAd';
import { interpolationInTime } from './InterpolationInTime';

export function getRewardedAdFallbackImage(options: {
    source: string;
    /** Duration for showing the close button. */
    duration: number;
    /** Description text. */
    cta: string;
}): IShowable {
    const root = getHTMLRewardedAd(true);
    const { img, txt, btnClose, overlay } = extractHTMLRewardedAdElementsFallback(root);

    return {
        loadAsync: async () => {
            return new Promise<void>((resolve, reject) => {
                const successFunc = () => {
                    removeListenersFunc();
                    resolve();
                };
                const failFunc = () => {
                    removeListenersFunc();
                    reject('fail to load image');
                };
                const removeListenersFunc = () => {
                    img.removeEventListener('load', successFunc, true);
                    img.removeEventListener('error', failFunc, true);
                };

                // Update description text.
                txt.innerText = options.cta;

                img.addEventListener('load', successFunc, true);
                img.addEventListener('error', failFunc, true);
                img.src = options.source;
            });
        },
        showAsync: async () => {
            return new Promise<void>(resolve => {
                document.body.appendChild(root);

                // Circle time progression.
                const progressUpdateFunc = createCircleProgressFunc(root);
                const progressCompleteFunc = createCircleCompleteFunc(root);
                const lerp = interpolationInTime(options.duration, progressUpdateFunc, progressCompleteFunc);

                const closeFunc = () => {
                    lerp.stop();
                    root.remove();

                    // Remove event listeners.
                    img.removeEventListener('error', close, true);
                    btnClose.removeEventListener('click', closeFunc, true);

                    resolve();
                };

                // Add event listeners.
                img.addEventListener('error', closeFunc);
                btnClose.addEventListener('click', closeFunc, true);
            });
        },
    };
}
